import React from 'react';

import { ReactComponent as Nature } from '@assets/images/icons/nature.svg';
import { ReactComponent as World } from '@assets/images/icons/world.svg';

import ArrowDown from '@assets/images/arrow-down.svg';

type BlockArrowTypes = {
  active?: boolean;
  onClick: (param: boolean) => void;
  isDesktopOrLaptop?: any;
};

export const BlockArrow: React.FC<BlockArrowTypes> = ({ active, onClick, isDesktopOrLaptop }) => {

  if (isDesktopOrLaptop) {
    return (
      <div
        className="
          flex
          flex-col
          lg:flex-row
          justify-center
          items-center
          lg:items-center
          w-full
          pt-9
          pb-18
          max-w-1160
          mx-auto
          arrow-down
        "
      >
        <img src={ArrowDown} width="30" height="40" alt="" />
      </div>
    );
  } else {
    return (
      <div
        className="
          bg-smGrayText
          fixed
          left-0
          right-0
          bottom-0
          flex
          items-center
          justify-between
          px-5
          pt-2.5
          pb-2.5
          z-20
          fixed-menu
        "
      >
        <div
          onClick={() => onClick(true)}
          className={`
            flex
            justify-center
            items-center
            flex-1
            rounded-l-xl
            border-grayText
            ${active ? 'bg-mdGrayText' : 'bg-ltGrayText'}
            border
            h-8
          `}
        >
          <Nature
            className={`
              fill-current
              ${active ? 'text-greenText' : 'text-lgGrayText'}
            `}
            width={20}
            height={20}
          />
          <span
            className={`
              ml-2.5
              ${active ? 'text-greenText' : 'text-lgGrayText'}
              text-xs
            `}
          >Природа</span>
        </div>
        <div
          onClick={() => onClick(false)}
          className={`
            flex
            justify-center
            items-center
            flex-1
            rounded-r-xl
            border-grayText
            ${active ? 'bg-ltGrayText' : 'bg-mdGrayText'}
            border
            border-l-0
            h-8
          `}
        >
          <World
            className={`
              fill-current
              ${active ? 'text-lgGrayText' : 'text-redText'}
            `}
            width={22}
            height={22}
          />
          <span
            className={`
              ml-2.5
              ${active ? 'text-lgGrayText' : 'text-redText'}
              text-xs
            `}
          >Лаборатория</span>
        </div>
      </div>
    );
  }
}